import axios from 'axios'

export default {
    reportBug(payload) {
        return axios.post('/unauthenticated/support/report-bug', payload)
    },
}
